export default __webpack_public_path__ + "static/media/time-to-draw-title.a688bd03.webp";